import { END_POINTS } from '../helpers';
import { BannerData, BannerResponse, CommonBody } from '../types/General';
import emptySplitApi from '../utils/rtk';
type CommonResponse = {
  statusCode: number;
  message?: string;
};
export const bannerAPi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    addBanner: builder.mutation<CommonResponse & { data: any }, { body: CommonBody }>({
      query: ({ body }) => ({
        url: `${END_POINTS.addBanner}`,
        method: 'POST',
        body,
      }),
    }),
    updateBanner: builder.mutation<
      CommonResponse & { data: any },
      { body: CommonBody; id: string }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateBanner}/${id}`,
        method: 'PUT',
        body,
      }),
    }),
    deleteBanner: builder.mutation<CommonResponse & { data: any }, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteBanner}/${id}`,
        method: 'DELETE',
      }),
    }),
    getBannerById: builder.query<CommonResponse & { data: BannerData }, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.getBannerById}/${id}`,
        method: 'GET',
      }),
    }),
    getBanner: builder.query<
      CommonResponse & { data: BannerResponse },
      { page: number; limit: number; search: string }
    >({
      query: ({ page, limit, search }) => {
        const params = new URLSearchParams();
        if (search) {
          params.append('search', search);
        }
        return {
          url: `${END_POINTS.getBanner}?page=${page}&limit=${limit}&${params.toString()}`,
          method: 'GET',
        };
      },
    }),
  }),
});

export const {
  useAddBannerMutation,
  useLazyGetBannerQuery,
  useDeleteBannerMutation,
  useUpdateBannerMutation,
  useLazyGetBannerByIdQuery,
} = bannerAPi;
